export default {
  name: 'Content section - 1',
  tab: 'content',
  type: 'content-default-section',
  content: {
    title: '',
    introtext: '',
    image: null,
    buttons: '[]'
  },
  design: {
    'background-color': 'var(--background-color)',
    'background-image':
      '/storage/media/samples/ian-dooley-TevqnfbI0Zc-unsplash.jpg',
    'background-image-tablet': '',
    'background-image-mobile': '',
    'parallax-background-image': '0',
    'custom-padding': '1',
    'padding-top': '500px',
    'padding-bottom': '60px',
    'title-color': 'inherit',
    'title-font-weight': 'var(--title-font-weight)',
    'title-tag': 'h4',
    'introtext-color': 'inherit'
  },
  layout: {
    'content-container-fluid': '0',
    'content-container-size': 'sm',
    'content-horizontal-alignment': 'center',
    'content-box': '0',
    'content-box-color': 'var(--primary-color)',
    'content-box-padding': '30px',
    'content-box-opacity': '0.9',
    'content-box-elevation': '0',
    'content-box-border': '0',
    'content-box-border-color': 'var(--text-dark-color)',
    'content-box-rounded': '0'
  },
  advanced: {}
}
